import React, { useState, useEffect, useRef } from "react";
import { getPrompts } from "../../../config/apiConfig";
import { AgGridReact } from "ag-grid-react";
import { sbaAxios } from "../../utils/sbaAxios";
import { TopBar } from "../../shared/topBar/TopBar";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { SBAComboBox } from "../../UiComponents/SBADropDown";
import moment from "moment";
import { Modal, Form } from "react-bootstrap";
import * as XLSX from "xlsx";

export const GenAIPrompts = () => {

  const viewByOptions = [
    {viewByName: "Default", viewByValue: "default"},
    {viewByName: "Prompts", viewByValue: "Prompt"},
    {viewByName: "Dates", viewByValue: "CreatedDate"},
    {viewByName: "Users", viewByValue: "UserName"},
    {viewByName: "Feedbacks", viewByValue: "Feedback"}
  ]
  const [gridData, setGridData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [prompt, setPrompt] = useState(null);
  const [response, setResponse] = useState(null);
  const [sqlCommand, setSqlCommand] = useState(null);
  const [groupBy, setGroupBy] = useState(viewByOptions[0]);
  const [colDefs, setColDefs] = useState([]);

  const gridRef = useRef();

  let Level = [{ BreadCrumb: "Admin > ", Routes: `${UrlPath.Admin}` }];
  Level = [
    ...Level,
    { BreadCrumb: "ChatBot Usage Logs", Routes: `${UrlPath.ChatBotUsageLogs}` },
  ];

  const getFormattedDate = (value) => {
    console.log('time, ')
    return value ? moment(value).format("MM-DD-YYYY hh:mm A") : "";
  };

  const getAIPrompts = async () => {
    try {
      const response = await sbaAxios({
        url: `${getPrompts}`,
        method: "get",
      });
      if (response) {
        setGridData(
          response.map((item) => ({
            ...item,
            CreatedDate: getFormattedDate(item.CreatedDate),
          }))
        );
      }
    } catch (e) {
      console.log(e, "Error Fetching the view data");
    }
  };

  useEffect(() => {
    getAIPrompts();
  }, []);

  useEffect(() => {
    updateColDefs();
  }, [groupBy]);

  const updateColDefs = () => {
    const baseCols = [
      { headerName: "Prompt", field: "Prompt", rowGroup: false, hide: false },
      { headerName: "Date", field: "CreatedDate", rowGroup: false, hide: false },
      { headerName: "Name", field: "UserName", rowGroup: false, hide: false },
      { headerName: "Feedback", field: "Feedback", rowGroup: false, hide: false },
      { headerName: "Remarks", field: "Remarks", rowGroup: false, hide: false },
      { headerName: "TimeDifference", field: "TimeDifference", rowGroup: false, hide: false },
    ];

    if (groupBy.viewByValue !== "default") {
      setColDefs(
        baseCols.map((col) =>
          col.field === groupBy.viewByValue
            ? { ...col, rowGroup: true, hide: true } // Enable grouping
            : col
        )
      );
    } else {
      setColDefs(baseCols); // Reset to default
    }
  };

  const defaultColDef = {
    sortable: true,
    filter: true,
    floatingFilter: true,
    flex: 1,
    filter: "agTextColumnFilter",
    resizable: true,
  };

  const handleRowClick = (event) => {
    if (event.node.group) {
      return; 
    }
    setPrompt(event.data?.Prompt);
    setResponse(event.data?.PromptResponse);
    setSqlCommand(event.data?.SqlQueryText);
    setShowModal(true);
  };

  const exportToExcel = () => {
    if (!gridRef.current) return;

    gridRef.current.api.exportDataAsExcel({
        fileName: "ChatBot_Logs.xlsx",
        processCellCallback: (params) => {
            if (params.node.group) {
              return params.value; // Skip processing for grouped rows
            }
            if (params.column.colDef.field === "Feedback") {
              return params.value === true ? "Positive" : params.value === false ? "Negative" : "Neutral";
            }
            return params.value;
        },
        processHeaderCallback: (params) => params.column.colDef.headerName,
    });
};

  return (
    <>
        <div className="container-fluid">
          {/* Dropdown for Grouping */}
          <div className="row mb-2">
          <div className="col d-flex justify-content-end align-items-center gap-3">
              <label className="label" >View by:</label>
                    <div>
                        <SBAComboBox
                            className="w-100"
                            data={viewByOptions}
                            textField={"viewByName"}
                            valueField={"viewByValue"}
                            value={groupBy}
                            onChange={(e)=>setGroupBy(e.value)}
                            popupSettings={{ className: "modalDD" }}
                        ></SBAComboBox>
                    </div>
                    <button className="p-sm-btn mb-2" onClick={exportToExcel}>
                      Export to Excel
                    </button>
                    <button className="p-sm-btn mb-2" onClick={getAIPrompts}>
                      Refresh Grid
                    </button>
              </div>
          </div>

          <div className="ag-theme-alpine m-1" style={{ height: "700px" }}>
            <AgGridReact
              ref={gridRef}
              key={groupBy} // 🔥 Forces AG Grid to reset when changing groups
              rowData={gridData}
              columnDefs={colDefs}
              defaultColDef={defaultColDef}
              animateRows={true}
              suppressAggFuncInHeader={true} // Prevents unwanted header aggregation
              groupDisplayType="singleColumn"
              onRowClicked={handleRowClick}
            />
          </div>

          {/* Modal */}
          {showModal && (
            <Modal show={showModal} onHide={() => setShowModal(false)} dialogClassName="modal-xl">
              <Modal.Header closeButton>
                <Modal.Title>User Prompt Info</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ maxHeight: "400px", overflowY: "auto" }}>
                <div className="row">
                  <h3>Prompt:</h3>
                </div>
                <div className="row mt-2">
                  <p>{prompt}</p>
                </div>
                <hr />
                <div className="row mt-2">
                  <h3>Response:</h3>
                </div>
                <div className="row mt-2">
                  <p>{response}</p>
                </div>
                <hr />
                <div className="row mt-2">
                  <h3>SQL Command:</h3>
                </div>
                <div className="row mt-2">
                  <p>{sqlCommand}</p>
                </div>
              </Modal.Body>
            </Modal>
          )}
        </div>
    </>
  );
};
